import type { ReactNode } from 'react';
import { cn } from '../lib/cn';

interface Props {
  children: ReactNode;
  tone?: 'neutral' | 'success' | 'warning' | 'danger' | 'brand';
  className?: string;
}

export function Badge({ children, tone = 'neutral', className }: Props): JSX.Element {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-pill px-2.5 py-0.5 text-xs font-medium',
        tone === 'neutral' && 'bg-[var(--border-light)] text-tg-text',
        tone === 'success' && 'bg-brand-green/15 text-brand-green',
        tone === 'warning' && 'bg-[var(--warning)]/15 text-[var(--warning)]',
        tone === 'danger' && 'bg-destructive/15 text-destructive',
        tone === 'brand' && 'bg-brand-navy text-brand-cream',
        className,
      )}
    >
      {children}
    </span>
  );
}
